import React, { useEffect, useState, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import "./MobileOtpPage.css";
import { useDispatch, useSelector } from "react-redux";
import FormInputStyle2 from "../../../../components/Form/FormInputStyle2";
import FormSelectStyle2 from "../../../../components/Form/FormSelectStyle2";
import FormButtonStyle2 from "../../../../components/Form/FormButtonStyle2";
import moment from "moment";
import { toast } from "react-toastify";
import callApi from "../../../../utility/apiCaller";
import { setUserClickData } from "../../../../utility/setUserClickData";
import { useNavigate } from "react-router-dom";
import { v6 as uuid } from "uuid";
import {
  login,
  setAllOffers,
  setLead,
  setOffers,
} from "../../../../store/app/appReducer";
import OTPInput from "react-otp-input";
import FormButtonStyleCheckOffer from "../../../../components/Form/FormButtonStyleCheckOffer";
import axios from "axios";
import _ from "lodash";
import {
  setAmountRequired,
  setAppId,
  setEmendateUrl,
  setInternalLead,
  setKfsUrl,
  setKycurl,
  setLeadId,
  setOpportunityId,
  setOpportunityName,
  setResponse,
  setUserData,
} from "../../../../store/app/aaSlice";
import useAddLead from "../../hooks/addLeadtoCRM";
import HeroSection from "../HeroSection/heroSection";
import StickyCtaBar from "../../UIElements/StickyCtaBar";

const MobileOtpPage = ({
  isFormStarted,
  setIsFormStarted,
  currentStep,
  setCurrentStep,
  formData,
  setFormData,
}) => {
  const [mobile, setMobile] = useState("");
  const [name, setName] = useState("");
  const prefillNameRef = useRef(""); // name fetched from mobile-to-prefill (for dmi-lead at OTP)
  const [errors, setErrors] = useState({});
  const [isMobileValid, setIsMobileValid] = useState(true);
  const [source, setSource] = useState("");
  const [utmSource, setUtmSource] = useState("");
  const [utmMedium, setUtmMedium] = useState("");
  const [utmTerm, setUtmTerm] = useState("");
  const [affId, setAffId] = useState("");
  const [params] = useSearchParams();
  const [isConsentChecked, setIsConsentChecked] = useState(false);
  const [isPrefrConsentChecked, setIsPrefrConsentChecked] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [activeLenders, setActiveLenders] = useState([]);
  const [isTncChecked, setIsTncChecked] = useState(true);
  const [isOtpGenerated, setIsOtpGenerated] = useState(false);
  const [otp, setOtp] = useState("");
  const dispatch = useDispatch();
  const [leadId, setLeadId1] = useState("");
  const [searchParams] = useSearchParams();
  const addLead = useAddLead();
  const RESEND_OTP_TIME = 30;

  const [resendCounter, setResendCounter] = useState(RESEND_OTP_TIME);
  const [canResendOtp, setCanResendOtp] = useState(false);


  const lid = searchParams.get("lid");
  const a = Number(params.get("a"));

  const [ipAddress, setIpAddress] = useState("");

  const handleNameChange = (e) => {
    let newName = e.target.value;

    // Remove any character that is not a letter or space
    newName = newName.replace(/[^A-Za-z\s]/g, "");

    // Replace multiple spaces with a single space
    newName = newName.replace(/\s+/g, " ");

    setName(newName);

    // Validate: name must have at least 2 characters after trimming
    setErrors((prev) => ({
      ...prev,
      name: newName.trim().length < 2,
    }));
  };

  async function fetchIp() {
    await fetch("https://api.ipify.org?format=json")
      .then((response) => response.json())
      .then((data) => {
        // ipAddress = data?.ip;
        setIpAddress(data?.ip);
        setFormData((prev) => ({ ...prev, ip_address: data?.ip }));
      })
      .catch((error) => {
        console.log("Error:", error);
      });
  }
  useEffect(() => {
    fetchIp();
  }, []);

  useEffect(() => {
    if (!isOtpGenerated) return;

    setResendCounter(RESEND_OTP_TIME);
    setCanResendOtp(false);

    const interval = setInterval(() => {
      setResendCounter(prev => {
        if (prev <= 1) {
          clearInterval(interval);
          setCanResendOtp(true);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [isOtpGenerated]);


  useEffect(() => {
    if (params.get("source")) setSource(params.get("source"));
    if (params.get("utm_source")) setUtmSource(params.get("utm_source")?.split("?")[0]);
    if (params.get("utm_medium")) setUtmMedium(params.get("utm_medium"));
    if (params.get("utm_term")) setUtmTerm(params.get("utm_term"));
    if (params.get("aff_id")) setAffId(params.get("aff_id"));
    if (params.get("lid")) setLeadId1(params.get("lid"));
  }, [params]);

  useEffect(() => {
    const container = document.getElementById("personal-loan-form");
    if (container)
      container.resetOtpState = () => {
        setIsOtpGenerated(false);
        setOtp("");
      };
  }, []);

  // Active-lender fetch removed on purpose: the resume flow now shows every
  // generated offer regardless of a lender's "active" status, matching the
  // normal (Professional -> Offer) flow, which never fetches active lenders.
  // `activeLenders` stays [] so the STEP 5 filter in fetchOffers is a no-op.

  let allianceId = "multistep-pl-ete-lead";

  if (a == 2) {
    allianceId = "zv2";
  } else if (a == 3) {
    allianceId = "zv3";
  } else if (a == 4) {
    allianceId = "zv4";
  }

  const fetchOffers = async (leadId, token) => {
    if (!leadId) return false;

    try {
      // STEP 1: Fetch base offers.
      // Use the SAME endpoint the normal flow (ProfessionalInfoForm) uses so the
      // resume path returns the same offers for a lead. loan_offer/lead_id is a
      // dedicated per-lead lookup with no date/alliance filters that could hide
      // an existing offer (unlike loan_offer/list + the hardcoded created_at).
      const res = await callApi(
        `v1/loan_offer/lead_id/${leadId}`,
        "get",
        {},
        "core",
        token
      );

      if (res.status !== "Success" || !Array.isArray(res.data?.offers)) {
        return { success: false, offers: [] };
      }

      const offers = res.data.offers;
      // STEP 2: Fetch lender success/fail list
      const lenderListRes = await callApi(
        `v1/lender_api_call/${leadId}/get-fail-success-lenders`,
        "post",
        {},
        "loan",
        token
      );

      let lenderMap = {};

      const failedList =
        lenderListRes.data?.FailListDetails ??
        lenderListRes.data?.FailList ??
        [];

      if (
        lenderListRes.status === "Success" &&
        Array.isArray(lenderListRes.data?.Successlist)
      ) {
        lenderMap = Object.fromEntries(
          lenderListRes.data.Successlist.map((lender) => [
            lender.lender_id,
            lender,
          ])
        );
      }

      // STEP 3: Enrich base offers using success lenders
      const enrichedOffers = offers.map((offer) => {
        const lender = lenderMap[offer.lender_id] || {};

        return {
          ...offer,
          apr: lender.apr ?? "",
          kfs_doc: lender.kfs_doc ?? "",
          credit_limit: offer.credit_limit ?? offer.max_amount ?? "",
          penal_charges: lender.penal_charges ?? "",
          processing_fee: lender.processing_fee ?? "",
          interest_rate: lender.web_interest ?? null,
          lender_name: lender.lender_name ?? offer.lender_name,
          rect_lender_logo: lender.rect_lender_logo ?? "",
          priority: lender.priority ?? offer.priority ?? 999,
        };
      });

      // STEP 4: Sort by priority
      const sortedOffers = _.orderBy(enrichedOffers, ["priority"], ["asc"]);

      // STEP 5: Filter by active lenders if present
      const filteredOffers = activeLenders.length
        ? sortedOffers.filter((offer) =>
          activeLenders.some((lender) => lender._id === offer.lender_id)
        )
        : sortedOffers;

      return {
        success: true,
        offers: filteredOffers,
        failedList: failedList,
      };
    } catch (err) {
      console.error("Error in offer fetching", err);
      // toast.error("Something went wrong while fetching offers.");
      return { success: false, offers: [] };
    }
  };

  const generateLead = async (token) => {
    try {
      // -----------------------------
      // 1️⃣ CREATE LEAD (DMI LEAD API)
      // -----------------------------
      const res = await callApi(
        "v1/lead/dmi-lead",
        "post",
        {
          lead: {
            contact_phone: mobile,
            contact_name: name || prefillNameRef.current || "NA",
            steps_completed: 1,
            alliance_id: allianceId,
            aff_id: params.get("aff_id") || null,
            utm_source: params.get("utm_source")?.split("?")[0] || null,
            source: params.get("source") || null,
            utm_medium: params.get("utm_medium") || null,
            utm_term: params.get("utm_term") || null,
            ads_name: params.get("ads_name") || null,
            ip_address: ipAddress,
            kyc_consent: isTncChecked,
            kyc_consent_datetime: new Date().toISOString(),
            website_kyc_consent: isTncChecked,
            website_kyc_consent_datetime: new Date().toISOString(),
            otp_page: "multistep-pl-v1",
            //prefr_kyc_consent: isPrefrConsentChecked,
          },
        },
        "core",
        token
      );

      // -----------------------------
      // 2️⃣ VALIDATE RESPONSE
      // -----------------------------
      if (!res || res.status !== "Success") {
        console.error("DMI Lead API failed:", res);
        // toast.error("Unable to create lead at the moment.");
        return false;
      }

      const finalLeadId = res?.data?.lead?._id;

      if (!finalLeadId) {
        console.error("Lead ID missing in response:", res);
        // toast.error("Lead creation failed due to invalid response.");
        return false;
      }

      // -----------------------------
      // 3️⃣ STORE INTERNAL LEAD ID
      // -----------------------------
      dispatch(setInternalLead(finalLeadId));

      // -----------------------------
      // 4️⃣ ADD LEAD TO CRM SYSTEM
      // -----------------------------
      try {
        await addLead({
          leadId: finalLeadId,
          lead_type: "live",
          priority: 4,
          stage: "OTP",
        });
      } catch (crmError) {
        console.error("Error adding lead to CRM:", crmError);
        // optionally show toast but not required
      }

      return finalLeadId; // useful if caller needs it
    } catch (error) {
      // -----------------------------
      // 5️⃣ GLOBAL ERROR CATCH
      // -----------------------------
      console.error("Unexpected error in generateLead:", error);
      // toast.error("Something went wrong while generating lead.");
      return false;
    }
  };

  // useEffect(() => {
  //   const fetchLeadData = async () => {
  //     try {
  //       if (leadId) return;

  //       const response = await callApi(
  //         "v1/lead/list",
  //         "post",
  //         {
  //           filters: { _id: lid },
  //         },
  //         "core" // specify the core service here
  //       );

  //       const lead = response?.data?.leadList?.[0];
  //       console.log(lead); // assuming API returns array of leads

  //       if (lead) {
  //         setMobile(lead?.contact_phone || "");

  //         // Update the overall formData too
  //       }
  //     } catch (error) {
  //       console.error("Failed to fetch lead data:", error);
  //     }
  //   };

  //   fetchLeadData();
  // }, [setFormData]);

  const handleMobileChange = (event) => {
    const value = event.target.value;

    if (/^\d*$/.test(value)) {
      setMobile(value);
      setFormData((prev) => ({
        ...prev,
        mobile: value,
      }));
    }

    setIsMobileValid(value.length === 10);
  };

  const handleConsentChange = () => {
    setIsConsentChecked((prev) => !prev);
  };

  const handlePrefrConsentChange = () => {
    setIsPrefrConsentChecked((prev) => !prev);
  };

  const handleValidation = () => {
    let isValid = true;

    // if (!mobile || mobile.trim() === "") {
    //   isValid = false;
    //   setIsMobileValid(false);
    // }
    if (!/^\d{10}$/.test(mobile) || mobile.length !== 10) {
      isValid = false;
      setIsMobileValid(false);
    } else {
      setIsMobileValid(true);
    }

    return isValid;
  };

  // Records the T&C / KYC consent in the lead_consent collection via the
  // core service, the same way generateLead posts to the core service.
  // Best-effort: callers must not let a failure here block the OTP flow.
  const recordConsent = async () => {
    try {
      const res = await callApi(
        "v1/consent/create",
        "post",
        {
          contact_name: formData.fullName || formData.name || undefined,
          contact_phone: mobile,
          lead_type: "web",
          utm_source: params.get("utm_source")?.split("?")[0] || null,
          utm_medium: params.get("utm_medium") || null,
          aff_id: params.get("aff_id") || null,
          ip_address: ipAddress,
          kyc_consent_datetime: new Date().toISOString(),
        },
        "core"
      );
      return res;
    } catch (consentError) {
      console.error("Failed to record consent:", consentError);
    }
  };

  const handleSendOtp = async () => {
    if (!handleValidation()) {
      return;
    }
    if (!isConsentChecked) {
      toast.error("Please agree to the Terms and Conditions.");
      return;
    }
    if (!isPrefrConsentChecked) {
      // toast.error("Please agree to the Prefr Terms & Conditions to continue.");
      return;
    }

    try {
      setIsLoading(true);
      const response = await callApi(
        "v1/sms/send-otp",
        "post",
        {
          contact_phone: mobile,
          kyc_consent: isConsentChecked,
          kyc_consent_datetime: new Date().toISOString(),
          website_kyc_consent: isTncChecked,
          website_kyc_consent_datetime: new Date().toISOString(),
          //prefr_kyc_consent: isPrefrConsentChecked,
        },
        "messaging"
      );
      if (response.status === "Success") {
        setUserClickData({
          event_name: `otp-send-for-multistep-pl-v1`,
          user_id: mobile || "unknown",
          affiliate_id: affId || "No Aff_id found",
          utm_source: utmSource || utmMedium,
          utm_term: utmTerm,
        });
        setFormData((prev) => ({
          ...prev,
          mobile,
          mobiletncchecked: true,
          mobiletnctime: new Date().toISOString(),
          stepDone: 3,
        }));
        // toast.success("OTP Sent Successfully");
        setIsOtpGenerated(true);
        setIsFormStarted(true);

        // Record the T&C / KYC consent (best-effort; never blocks OTP).
        await recordConsent();
      } else {
        // toast.error("Failed to send OTP. Please try again.");
      }
    } catch (error) {
      // toast.error("An error occurred while sending OTP.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleResendOtp = async () => {
    if (!canResendOtp) return;

    try {
      setIsLoading(true);

      const response = await callApi(
        "v1/sms/send-otp",
        "post",
        {
          contact_phone: mobile,
          kyc_consent: isConsentChecked,
          kyc_consent_datetime: new Date().toISOString(),
          website_kyc_consent: isTncChecked,
          website_kyc_consent_datetime: new Date().toISOString(),
          //prefr_kyc_consent: isPrefrConsentChecked,
        },
        "messaging"
      );

      if (response.status === "Success") {
        setUserClickData({
          event_name: `resend-otp-form-for-multistep-pl-v1`,
          user_id: mobile || "unknown",
          affiliate_id: affId || "No Aff_id found",
          utm_source: utmSource || utmMedium,
          utm_term: utmTerm,
        });

        // toast.success("OTP Resent Successfully");

        // 🔁 restart timer
        setResendCounter(RESEND_OTP_TIME);
        setCanResendOtp(false);
      } else {
        // toast.error("Failed to resend OTP.");
      }
    } catch (error) {
      console.error(error);
      // toast.error("An error occurred while resending OTP.");
    } finally {
      setIsLoading(false);
    }
  };
  const fetchAndApplyPrefillData = async (mobileNumber) => {
    try {
      // Production lender mobile-to-prefill endpoint (application/json).
      const prefillRes = await axios.post(
        "https://loan-api.digitmoney.in/api/v1/lender/mobile-to-prefill",
        { mobile_number: mobileNumber },
        { headers: { "Content-Type": "application/json" } }
      );

      const prefill = prefillRes?.data?.data?.data;
      if (prefillRes?.data?.status === "Success" && prefill) {
        prefillNameRef.current = prefill.full_name || "";
        setFormData((prev) => ({
          ...prev,
          fullName: prefill.full_name || prev.fullName,
          pancard: prefill.pan_number || prev.pancard,
          email: prefill.email || prev.email,
          gender: prefill.gender || prev.gender,
          dob: prefill.dob
            ? moment(prefill.dob, "YYYY-MM-DD").format("DD MM YYYY")
            : prev.dob,
          pincode: prefill.address?.zip || prev.pincode,
          // Kept for any later step that may want the full address;
          // Personal Details itself only consumes pincode from this.
          prefillAddress: prefill.address || prev.prefillAddress,
        }));
      }
    } catch (prefillError) {
      console.error("Failed to fetch mobile-to-prefill data:", prefillError);
    }
  };

  const fetchLeadData = async (token) => {
    try {
      if (leadId) return { hasLead: false, hasOffer: false };

      const startDate = moment()
        .subtract(1, "months")
        .startOf("day")
        .toISOString();
      const endDate = moment().endOf("day").toISOString();

      const response = await callApi(
        "v1/lead/list",
        "post",
        {
          filters: {
            contact_phone: mobile,
            created_at: {
              $gte: startDate,
              $lte: endDate,
            },
          },
        },
        "core"
      );

      const sortedLeads = (response?.data?.leadList || []).sort(
        (a, b) =>
          new Date(b.updatedAt || b.createdAt) -
          new Date(a.updatedAt || a.createdAt)
      );

      const lead = sortedLeads[0];
      let hasLead = false;
      let hasOffer = false;
      let currentLeadId = null;

      if (lead) {
        const { _id, steps_completed } = lead;
        console.log(_id, steps_completed);
        hasLead = true;
        currentLeadId = _id;

        if (steps_completed > 3) {
          console.log("lead: ", lead);
          const {
            _id = "",
            steps_completed = 0,
            application_id = "",
            dmi_lead_response_id = "",
            dmi_lead_id = "",
            dmi_offer = "",
            dmi_opportunityid = "",
            amount_required,
            kycurl = "",
            emandateurl = "",
            dmi_opportunityName = "",
            dmi_offers_details,
          } = lead;

          let startStep = 1;

          // 🔑 update redux
          console.log({
            setInternalLead,
            setResponse,
            setAppId,
            setLeadId,
            setOpportunityId,
            setKycurl,
            setAmountRequired,
            setKfsUrl,
            setUserData,
            setEmendateUrl,
            setOpportunityName,
            setOffers,
          });

          dispatch(setInternalLead(_id));
          dispatch(setResponse(dmi_lead_response_id));
          dispatch(setAppId(application_id));
          dispatch(setLeadId(dmi_lead_id));
          // dispatch(setOffers(dmi_offer));
          dispatch(setOpportunityId(dmi_opportunityid));
          dispatch(setKycurl(kycurl));
          dispatch(setAmountRequired(amount_required));
          dispatch(setKfsUrl(lead.kfsurl));
          dispatch(setUserData(lead));
          dispatch(setEmendateUrl(emandateurl));
          dispatch(setOpportunityName(dmi_opportunityName));
          dispatch(setOffers(dmi_offers_details));

          // Check if there are offers
          hasOffer = !!(
            dmi_offers_details &&
            (Array.isArray(dmi_offers_details)
              ? dmi_offers_details.length > 0
              : Object.keys(dmi_offers_details).length > 0)
          );

          // 🔑 decide correct starting step
          if (!steps_completed || steps_completed === 0) {
            setCurrentStep(1);
          }
          if (steps_completed >= 3 && steps_completed <= 16) {
            startStep = steps_completed + 1;
          }

          setCurrentStep(startStep);
        } else {
          dispatch(setLead({ id: _id }));
          dispatch(setInternalLead(_id));
          setFormData((prev) => ({
            ...prev,
            // ── Personal Details page fields ──────────────────────────────
            // Keep whatever the MobilePrefill API (fetchAndApplyPrefillData,
            // called just before this) already put into formData. Only fall
            // back to the DB lead when prefill returned nothing for a field,
            // so the Personal page reflects the MobilePrefill result on every
            // OTP completion instead of being overwritten by the database.
            name: prev.name || lead.contact_name || "",
            mobile: prev.mobile || lead.contact_phone || "",
            email: prev.email || lead.contact_email || "",
            gender: prev.gender || lead.gender || "",
            pancard: prev.pancard || lead.pancard || "",
            pincode: prev.pincode || lead.pincode || "",
            dob: prev.dob || (lead?.dob ? moment(lead.dob).format("YYYY-MM-DD") : ""),
            // ── Later-step fields (Professional / Loan) still come from DB ──
            professionType: lead.profession_type || "",
            company_name: lead?.company_name,
            company_type: lead?.company_type,
            work_contact_email: lead?.work_contact_email,
            loan_purpose: lead?.loan_purpose,
            monthly_income: lead?.monthly_income,
            alliance_id: lead?.alliance_id,
            amountRange: lead?.amount_required || "",
            fundsTimeline: lead?.funds_timeframe || "",
          }));
          // Route based on how far the lead got (steps_completed from the DB):
          //   1 → Personal Details page        (step 2)
          //   2 → "How much do you need?" page  (LoanAmount, step "loan_amount")
          //   3 → Offer page                    (step 6)
          // Any other value falls back to the Personal Details page.
          //
          // IMPORTANT: only fetch offers when we are actually routing to the
          // Offer page (steps_completed === 3). Fetching them for earlier
          // steps populates `allOffers` in redux, which made the lender table
          // show amounts for leads that shouldn't be on the Offer page yet.
          const sc = Number(steps_completed);
          if (sc === 3) {
            const offer = await fetchOffers(_id, token);
            if (offer?.success && offer?.offers?.length > 0) {
              hasOffer = true;
              dispatch(
                setAllOffers({
                  offers: offer.offers,
                  failedList: offer.failedList,
                })
              );
            }
            setCurrentStep(6);
          } else if (sc === 2) {
            setCurrentStep("loan_amount");
          } else {
            setCurrentStep(2);
          }
        }
      } else {
        // No lead found, create the lead FIRST and wait for it to commit
        // before any downstream call (e.g. lead-from-phone) that looks the
        // lead up by phone — otherwise that lookup races ahead and 500s.
        await generateLead(token);
        setCurrentStep((prev) => prev + 1);
      }
      console.log("Fetched Lead:", lead);
      console.log("going to stpe ", currentStep);
      return { hasLead, hasOffer, leadId: currentLeadId };
    } catch (error) {
      console.error("Failed to fetch lead data:", error);
      return { hasLead: false, hasOffer: false, leadId: null };
    }
  };

  useEffect(() => {
    if (otp.length === 4 && !isLoading) {
      handleOtpSubmit();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [otp]);

  const handleOtpSubmit = async () => {
    if (otp.length !== 4) {
      // toast.error("Please enter a valid 4-digit OTP.");
      return;
    }

    try {
      setIsLoading(true);

      const otpResponse = await callApi(
        "v1/sms/validate-otp",
        "post",
        {
          contact_phone: mobile,
          otp,
        },
        "messaging"
      );

      if (otpResponse.status === "Success") {
        setUserClickData({
          event_name: `otp-submit-for-multistep-pl-v1`,
          user_id: mobile || "unknown",
          affiliate_id: affId || "No Aff_id found",
          utm_source: utmSource || utmMedium || "",
          utm_term: utmTerm,
        });
        // toast.success("OTP Verified Successfully");
        await fetchAndApplyPrefillData(mobile);
        const leadData = await fetchLeadData(otpResponse?.data.token);
        console.log("leadData: ", leadData);

        dispatch(
          login({
            ...otpResponse.data.customer,
            token: otpResponse.data.token,
          })
        );
        localStorage.setItem("mobile", mobile);

        // Call useAddLead hook twice if there is lead and offer
        if (leadData?.hasOffer && leadData?.leadId) {
          try {
            // Second CRM call to tag the lead as having an offer.
            // NOTE: page routing is decided in fetchLeadData based on
            // steps_completed, so we intentionally do NOT setCurrentStep here.
            await addLead({
              leadId: leadData.leadId,
              lead_type: "live",
              priority: 2,
              stage: "Have offer",
            });
          } catch (error) {
            console.error("Error adding offer to CRM:", error);
          }
        }
        const leadResponse = await callApi(
          "v1/lead/lead-from-phone",
          "post",
          {
            phone: mobile,
            otp_page: "multistep-pl-v1",
            ip_address: ipAddress,
            website_kyc_consent: isTncChecked,
            website_kyc_consent_datetime: new Date().toISOString(),
            //prefr_kyc_consent: isPrefrConsentChecked,
          },
          "core",
          otpResponse.data.token
        );
        // const leadResponse = await callApi(
        //   "v1/lead/lead-from-phone",
        //   "post",
        //   {
        //     phone: mobile,
        //     website_kyc_consent: isTncChecked,
        //     website_kyc_consent_datetime: new Date().toISOString(),
        //     utm_source: utmSource || utmMedium,
        //     otp_page: "offer-check-v1",
        //     ip_address: ipAddress,
        //   },
        //   "core",
        //   otpResponse.data.token
        // );

        // const leadId = leadResponse?.data?.lead?._id;
        // if (leadId) {
        //   try {
        //     await fetch(
        //       "https://campaigns.digitmoney.in/api/offercheck/requestjson.php?case=insert_digit_money_data",
        //       {
        //         method: "POST",
        //         headers: {
        //           "Content-Type": "application/json",
        //         },
        //         body: JSON.stringify({
        //           api_key: "fca6416db1074658d6b6823380d18f04",
        //           mobile: mobile,
        //           lead_id: leadId,
        //         }),
        //       }
        //     );
        //   } catch (e) {
        //     console.error("Error in external lead insert:", e);
        //   }
        // }
      } else {
        // toast.error("Invalid OTP. Please try again.");
      }
    } catch (otpError) {
      console.error("Error occurred while verifying OTP:", otpError);
      //toast.error("An error occurred while verifying OTP. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return !isOtpGenerated ? (
    <>
    <div className="dm-landing-v9 w-full max-w-[400px] mx-auto bg-white min-h-[100dvh] px-4 pb-[120px] flex flex-col font-atkinson">
      {/* Brand — uses your existing logo asset */}
      <div className="flex justify-center mt-2">
        <img src="/assets/img/Footer%20logo.png" alt="digitmoney" className="h-auto w-[148px]" />
      </div>

      <h1 className="text-center font-medium text-[30px] leading-[1.12] tracking-[-0.01em] mt-7 mb-8 text-[#1b1b1b]">
        Discover your loan<br />offers instantly.
      </h1>

      {/* Trust cards (Google rating + trusted-by) — full-width, responsive */}
      <img
        src="/assets/img/group505.png"
        alt="Google rating 4.7 out of 5, trusted by 100,000+ borrowers"
        className="w-full h-auto"
      />

      {/* Mobile number */}
      <div className="w-full h-[72px] flex flex-col justify-center border border-[#e6e6e6] rounded-[16px] px-4 mt-8">
        <div className="text-[13px] text-[#5f6066]">Mobile Number</div>
        <input
          inputMode="numeric"
          value={mobile}
          onChange={handleMobileChange}
          placeholder="10-digit mobile number"
          maxLength={10}
          id="mobile"
          className="w-full bg-transparent outline-none text-[18px] text-[#1b1b1b] mt-[3px] placeholder:text-[#b3b3b3]"
        />
      </div>

      {/* Consent (single checkbox drives both consents) */}
      <div className="flex items-start gap-[10px] mt-4">
        <input
          type="checkbox"
          id="consent"
          checked={isConsentChecked}
          onChange={(e) => {
            setIsConsentChecked(e.target.checked);
            setIsPrefrConsentChecked(e.target.checked);
          }}
          className="w-[20px] h-[20px] mt-[1px] flex-none accent-black"
        />
        <label htmlFor="consent" className="text-[10px] text-[#3a3a3a] leading-[1.4]">
          By submitting this form, you have read and agree to the{" "}
          <a className="underline text-[10px]" href="https://digitmoney.in/terms">Credit Report Terms of Use</a>,{" "}
          <a className="underline text-[10px]" href="https://digitmoney.in/terms">Terms of Use</a> &amp;{" "}
          <a className="underline text-[10px]" href="https://digitmoney.in/lenders">Privacy Policy</a> of DigitMoney &amp; its{" "}
          <a className="underline text-[10px]" href="https://digitmoney.in/lenders">Lending Partners</a>
        </label>
      </div>

      {/* Encryption note */}
      <div className="flex items-center gap-3 bg-[#f6f6f6] rounded-[16px] p-[14px] mt-12">
        <div className="w-10 h-10 rounded-[11px] bg-[#12f280] flex items-center justify-center flex-none">
          <img
            src={process.env.PUBLIC_URL + "/assets/img/protected.png"}
            alt=""
            aria-hidden="true"
            className="w-4 h-4 flex-none object-contain"
          />
        </div>
        <p className="text-[15px] text-[#3a3a3a] leading-[1.3]">
          Your data is <b>100% encrypted</b> and never shared without your consent.
        </p>
      </div>

      {/* Lending partners — auto-scrolling logo strip */}
      <div className="mt-8 -mx-4 overflow-hidden plv17-lenders-carousel-mask">
        <div className="plv17-lenders-carousel-track">
          <img
            src="/assets/bank_img/Group 527.png"
            alt="Our lending partners"
            loading="lazy"
            className="plv17-lenders-carousel-logo"
          />
          <img
            src="/assets/img/lenders/Group 527.png"
            alt=""
            aria-hidden="true"
            loading="lazy"
            className="plv17-lenders-carousel-logo"
          />
        </div>
      </div>
    </div>
    <StickyCtaBar>
      <button
        type="button"
        onClick={handleSendOtp}
        disabled={!isMobileValid || isLoading}
        id="btn-get-otp-landing-v9"
        className="tracking-btn-get-otp-landing-v4 w-full bg-black text-white font-bold text-[18px] rounded-[16px] py-[17px] active:scale-[0.99] transition-transform disabled:opacity-50"
      >
        Send OTP
      </button>
    </StickyCtaBar>
    </>
  ) : (
    <>
    <div className="dm-otp-v9 w-full max-w-[400px] mx-auto bg-white min-h-[100dvh] px-4 pb-[120px] flex flex-col font-atkinson">
      {/* Progress (1/4) */}
      <div className="flex items-center gap-[14px] pt-2 pb-1">
        <button
          type="button"
          onClick={() => { setIsOtpGenerated(false); setOtp(""); setCurrentStep(1); }}
          aria-label="Go back"
          className="w-6 h-6 flex-none flex items-center justify-center"
        >
          <img src={process.env.PUBLIC_URL + "/assets/icons/left_arrow.png"} alt="" className="w-5 h-5 object-contain" />
        </button>
        <div className="flex-1 h-[7px] rounded-[6px] bg-[#c9f7e0] overflow-hidden">
          <div className="h-full bg-[#12f280] rounded-[6px]" style={{ width: "25%" }} />
        </div>
        <span className="text-[15px] text-[#3a3a3a] flex-none">1/4</span>
      </div>

      <h1 className="font-bold text-[20px] leading-[1.15] tracking-[-0.01em] mt-6 text-[#1b1b1b]">
        Verify Your Mobile Number
      </h1>
      <p className="text-[14px] text-[#8b8b8b] mt-2">Your data is encrypted &amp; safe</p>
      <p className="text-[17px] text-[#3a3a3a] mt-4">
        OTP sent to +91 XXXXXX{mobile ? String(mobile).slice(-4) : "0000"}
      </p>

      <div className="mt-4">
        <OTPInput
          value={otp}
          onChange={(val) => setOtp(val)}
          numInputs={4}
          isInputNum={true}
          shouldAutoFocus={true}
          inputStyle={{
            width: "68px",
            height: "68px",
            borderRadius: "18px",
            border: "1.5px solid #dcdcdc",
            fontSize: "26px",
            textAlign: "center",
          }}
          containerStyle={{ display: "flex", gap: "27px", justifyContent: "center" }}
          renderInput={(props) => (
            <input {...props} inputMode="numeric" pattern="[0-9]*" />
          )}
        />
      </div>

      <p className="text-center text-[15px] text-[#3a3a3a] pt-6">
        Didn't receive the OTP? &nbsp;
        {canResendOtp ? (
          <span onClick={handleResendOtp} className="font-bold cursor-pointer">Resend OTP</span>
        ) : (
          <span className="font-bold">Resend in 00.{String(resendCounter).padStart(2, "0")} Sec</span>
        )}
      </p>
    </div>
    <StickyCtaBar>
      <button
        type="button"
        onClick={handleOtpSubmit}
        disabled={otp.length !== 4 || isLoading}
        id="btn-verify-otp-personal-details-v9"
        className="tracking-btn-verify-otp-personal-details-v5 w-full bg-black text-white font-bold text-[18px] rounded-[16px] py-[17px] active:scale-[0.99] transition-transform disabled:opacity-50"
      >
        Verify &amp; Continue
      </button>
    </StickyCtaBar>
    </>
  );
};

export default MobileOtpPage;